module.exports = __webpack_public_path__ + "media/images/about-page-09a6cf90fe1020dd47483d557a00d9c8.jpg";